import React from "react";
import { Link } from "react-router-dom";

import { getImgUrl } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer-outer-wrapper">
      <div className="container">
        <div className="row">
          <div className="col col-100 footer-menu-outer-wrapper">
            {/* <div className="footer-images-wrapper">
              <div className="tripadvisor-main-wrapper">
                <Img desktopImg="Footer/tripadvisorMain.png" />
              </div>
              <div className="info-main-wrapper">
                <a href="https://www.gov.il/en/service/virtual_office/">
                  <Img desktopImg="support.png" />
                </a>
              </div>
            </div> */}
            <div className="footer-menu-inner-wrapper footer-menu-inner-wrapper-1">
              <ul className="first">
                <li>
                  <Link className="first" to="/Pages/whereToGo">
                    لا تفوّتوا زيارة هذه الأماكن
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/TelAvivPage">تل أبيب</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/JerusalemPage">القدس</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/DeadSeaPage">البحر الميّت</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul>
                <li>
                  <Link className="first" to="/Pages/thingsToDo">
                    نشاطات ننصح بها
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Sensational_Beaches">
                    شواطئ رائعة
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/MosquesOfJaffa_ar">مساجد يافا</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Non_Stop_Markets">
                    أسواق بلا توقّف
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul className="">
                <li>
                  <Link className="first" to="/Pages/Videos">
                    فيديوهات
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/culinarytelaviv/Coffee_In_TelAviv">
                    قهوة في تل أبيب
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/deadsea/Natural_Spa">
                    البحر الميت
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Port_Pleasures">
                    ميناء يافا
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <div className="clear"></div>
            </div>
            <div className="ac-social-wrapper">
                  <div className="ac-inner-social-wrapper">
                        <div className="ac-social-col ac-social-col-1">
                              <a href="https://www.instagram.com/visit_israel/" >
                              <Img desktopImg="social/i.png" mobileImg="social/i.png"/>
                              </a>
                        </div>
                        {/* <div className="ac-social-col ac-social-col-2">
                              <a href="https://twitter.com/israeltourism" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'twitter', 'event_details':'', }})}>
                              <Img desktopImg="social/t.png" mobileImg="social/t.png"/>
                              </a>
                        </div> */}
                        <div className="ac-social-col ac-social-col-3">
                              <a href="https://www.youtube.com/@goisraelofficial" >
                              <Img desktopImg="social/y.png" mobileImg="social/y.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-4">
                              <a href="https://www.flickr.com/photos/israelphotogallery/sets/" >
                              <Img desktopImg="social/fl.png" mobileImg="social/fl.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-5">
                              <a href="https://www.facebook.com/visit.israel.ar" >
                              <Img desktopImg="social/f.png" mobileImg="social/f.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-6">
                              <a href="https://www.tiktok.com/@visit_israel">
                              <Img desktopImg="social/tiktok.png" mobileImg="social/tiktok.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-7">
                              <a href="https://www.linkedin.com/company/israel-ministry-of-tourism/" >
                              <Img desktopImg="social/linkedin.png" mobileImg="social/linkedin.png"/>
                              </a>
                        </div>
                  </div>
        </div>
            <div className="clear"></div>
            {/* <div class="ac-wrapper-telaviv-and-jerusalem-footer ac-flex ac-flex-row ac-flex-row-mob"> */}
              {/*<div class="telaviv-and-jerusalem-footer">
                              <a  class="jer-site" href="https://www.itraveljerusalem.com/" >الموقع الرسمي السياحي لمدينة القدس >></a>
                            </div>
                            <div class="ac-verti-line hide-on-mobile">  </div>
                            <div class="telaviv-and-jerusalem-footer">
                              <a class="tlv-site" href="https://visit.tel-aviv.gov.il/home" rel="noopener" >الموقع الرسمي السياحي لمدينة تل أبيب>></a>
                            </div>*/}
              {/* <div class="telaviv-and-jerusalem-footer">
                <a
                  class="ac-privacy-policy"
                  href="https://new.goisrael.com/international/Posts/telaviv/Privacy_Policy"
                  rel="noopener"
                >
                  سياسة الخصوصية >>
                </a>
              </div>
              <div class="telaviv-and-jerusalem-footer terms-of-use">
                <a
                  class="ac-terms-of-use"
                  href="//israel.travel/terms-of-use/"
                  rel="noopener"
                >
                  تعليمات الاستخدام >>
                </a>
              </div>
            </div> */}
          </div>
        </div>
       
        <div className="row">
          <div className="cradit">
            <p>
              الصور: غاي هيليلي، آدم برايمر، كفير بولتين، لينيا أندريس، كفير
              سيفان، حاييم يافيم، دانا فريلاندر، رفائيل بن آري، إيتامار غرينبرغ،
              موشيك ليندباوم
            </p>
            <p>
              حقوق الفيديو: قناة الطعام الإسرائيلية، بلدية تل أبيب- يافا،{" "}
              <span class="ac-en-font">UDINI PRODACTIONS</span>
            </p>
          </div>

          {/* <h4>لمزيد من عروض الأسعار:</h4>
          <div className="clear"></div>
          <div className="sites-logos">
            <div className="anoter-site-deal-logo">
              <a href="https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html">
                <Img desktopImg={"Footer/1.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a href="//www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bto%5D=0&aPriceRange%5Bfrom%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=false&bIsSitemap=false&">
                <Img desktopImg={"Footer/2.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a href="https://www.booking.com/city/il/tel-aviv.en-gb.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=GBP;changed_currency=1;top_currency=1">
                <Img desktopImg={"Footer/3.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a href="https://www.expedia.co.uk/Tel-Aviv.d180031.Holidays-City-Breaks">
                <Img desktopImg={"Footer/4.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a href="https://uk.hotels.com/de699178/hotels-tel-aviv-israel/">
                <Img desktopImg={"Footer/5.png"} />
              </a>
            </div>
          </div> */}

          <div className="clear"></div>
        </div>
      </div>
      <div className="container container-links">
        <ul>
          <li><a href="https://brochures.goisrael.com/"
                 target="_blank"
                //  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'brochures', 'event_details':'', }})}
              >OFFICIAL BROCHURE</a></li>
          <li><span> | </span></li>
          <li><a href="https://goisrael.com/Pages/Contact/"
                target="_blank"
                // onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'contact us', 'event_details':'', }})}
              >CONTACT US</a></li>
               <li><span> | </span></li>
          <li><a href="https://israel.travel/terms-of-use/"
                  target="_blank"
                  // onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'term of use', 'event_details':'', }})}
              >TERMS OF USE</a></li>
               <li><span> | </span></li>
          <li><a href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
                  // onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'privacy policy', 'event_details':'', }})}
              >
                  PRIVACY POLICY
                </a></li>
                 <li><span> | </span></li>
          <li><a href="https://eu.goisrael.com/Pages/Gallery/" 
                 target="_blank" 
                //  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'gallery', 'event_details':'', }})}
              >GALLERY</a></li>
               <li><span> | </span></li>
          <li><a href="https://eu.goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions"
                  target="_blank" 
                  // onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'faq', 'event_details':'', }})}
              >FAQ</a></li>
        </ul>
      </div>
    
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js